import { SignDataState, TransferState } from '../../types';

import { TONCOIN } from '../../../config';
import { processDeeplink } from '../../../util/deeplink';
import { getTranslation } from '../../../util/langProvider';
import { addActionHandler, setGlobal } from '../../index';
import {
  clearCurrentDappTransfer,
  clearCurrentSignature,
  clearCurrentTransfer,
  clearDappConnectRequest,
  updateCurrentSignature,
  updateCurrentTransfer,
  updateCurrentTransferByCheckResult,
} from '../../reducers';

addActionHandler('apiUpdate', (global, actions, update) => {
  switch (update.type) {
    case 'dappAlreadyConnected': {
      const { url } = update;
      actions.showDialog({
        title: 'Already Connected',
        message: 'Return to the dapp to proceed, or reconnect.',
        buttons: {
          confirm: { title: 'OK', action: url ? 'openReturnUrl' : undefined },
          ...(url && { cancel: { title: 'Cancel' } }),
        },
        ...(url && { entities: { url } }),
      });
      break;
    }

    case 'dappDisconnected': {
      const { url } = update;
      actions.showDialog({
        title: 'Dapp Disconnected',
        message: 'Please reconnect your wallet from the dapp.',
        buttons: {
          confirm: { title: 'OK', action: url ? 'openReturnUrl' : undefined },
          ...(url && { cancel: { title: 'Cancel' } }),
        },
        ...(url && { entities: { url } }),
      });
      break;
    }

    case 'createTransaction': {
      const {
        promiseId,
        amount,
        toAddress,
        comment,
        rawPayload,
        stateInit,
        checkResult,
      } = update;

      global = clearCurrentTransfer(global);
      global = updateCurrentTransfer(global, {
        state: TransferState.Confirm,
        toAddress,
        resolvedAddress: checkResult.resolvedAddress,
        isToNewAddress: checkResult.isToAddressNew,
        amount,
        comment,
        promiseId,
        tokenSlug: TONCOIN.slug,
        rawPayload,
        stateInit,
      });
      global = updateCurrentTransferByCheckResult(global, checkResult);
      setGlobal(global);

      break;
    }

    case 'completeTransaction': {
      const { activityId } = update;
      setGlobal(updateCurrentTransfer(global, {
        state: TransferState.Complete,
        txId: activityId,
      }));

      break;
    }

    case 'createSignature': {
      const { promiseId, dataHex } = update;

      global = clearCurrentSignature(global);
      global = updateCurrentSignature(global, {
        promiseId,
        dataHex,
      });
      setGlobal(global);

      break;
    }

    case 'showError': {
      const { error } = update;
      actions.showError({ error });

      break;
    }

    case 'dappConnect': {
      actions.apiUpdateDappConnect(update);

      break;
    }

    case 'dappConnectComplete': {
      global = clearDappConnectRequest(global);
      setGlobal(global);

      break;
    }

    case 'dappDisconnect': {
      const { url } = update;

      if (global.currentDappTransfer.dapp?.url === url) {
        global = clearCurrentDappTransfer(global);
        setGlobal(global);
      }
      break;
    }

    case 'dappLoading': {
      actions.apiUpdateDappLoading(update);

      break;
    }

    case 'dappCloseLoading': {
      actions.apiUpdateDappCloseLoading(update);

      break;
    }

    case 'dappSendTransactions': {
      actions.apiUpdateDappSendTransaction(update);
      break;
    }

    case 'dappSignData': {
      actions.apiUpdateDappSignData(update);
      break;
    }

    case 'updateDapps': {
      actions.getDapps();
      break;
    }

    case 'prepareTransaction': {
      const {
        amount,
        toAddress,
        comment,
        binPayload,
      } = update;

      global = clearCurrentTransfer(global);
      global = updateCurrentTransfer(global, {
        state: TransferState.Initial,
        toAddress,
        amount: amount ?? 0n,
        comment,
        tokenSlug: TONCOIN.slug,
        binPayload,
      });

      setGlobal(global);
      break;
    }

    case 'processDeeplink': {
      const { url, isFromInAppBrowser } = update;

      void processDeeplink(url, isFromInAppBrowser);
      break;
    }

    case 'dappTransferComplete': {
      // The modal may already show a newer request while this transaction is still being sent.
      // Closing the modal would reject that request as if the user had declined it.
      const { state, promiseId } = global.currentDappTransfer;
      if (state !== TransferState.None && promiseId === update.promiseId) {
        actions.closeDappTransfer();
        actions.showToast({ message: getTranslation('Successfully Sent'), icon: 'icon-check' });
      }
      break;
    }

    case 'dappSignDataComplete': {
      const { state, promiseId } = global.currentDappSignData;
      if (state !== SignDataState.None && promiseId === update.promiseId) {
        actions.closeDappSignData();
        actions.showToast({ message: getTranslation('Successfully Signed'), icon: 'icon-check' });
      }
      break;
    }
  }
});
